<!-- Use as template for other scorecards //-->
<template>
    <div>
        <!--
        Make sure the key is unique.
        api endpoint will be the part after "/api/private/scorecards/..."
        drill down rout is the "NAME" of the route in the router file.
        The style is the css class name for the section of scorecards to customize colors
        agent code will get passed from the view. Should come from url string or default to the current logged in user.
        filters will come from the view as well... may or may not be used.
        format can be "Currency" "Percentage" or don't pass anything for int.
            //-->
        <q-score-card key="QScoreCardRegistrations" title="Total Personal Registrations" api-endpoint="agent_events" drill-down-label="View Registrations" drill-down-route="Drilldown_Events" card-style="production" :agent-code="agentCode" :filters="filters" :hideGoal="true" :hideButtonIcon="true" :hideHistoricalData="true">
            Total registrations are updated daily.
        </q-score-card>
    </div>
</template>
<script>
import QScoreCard from "./QEventsScoreCard.vue"

export default {
    name: "QScoreCardRegistrations",
    props: ["agentCode", "filters"],
    data: function() { // data internal to component (not available outside)
        return {}
    },
    mounted: function() {},
    computed: {

    },
    methods: {

    },
    watch: {

    },
    components: {
        QScoreCard,
    }
}

</script>
<style scoped>
</style>
